import {ChangeDetectionStrategy, Component, Injector} from '@angular/core';
import {Log, LogTag} from '../../services/Log';
import {Observable, of} from 'rxjs';
import {PlayerList} from "../../player/player.list";
import {DS_API_URL} from "../../constants";

@Component({
  selector: 'app-json-list',
  template: `
    <div #component>
      <template #playercontainer></template>
      <ngx-flicking #flk [options]=options>
          <app-flicking-item flicking-panel *ngFor="let page of pages" class="flicking-panel"
                       [setParentPlayer]="this"
                       [setEditMode]="editMode"
                       [setPage]="page">
          </app-flicking-item>
      </ngx-flicking>
    </div>`,
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JsonListComponent extends PlayerList {
  constructor(protected  injector: Injector) {
    super(injector);

  }

  getConfig() { return this.data.Json[0].$; }
  getScene() { return this.data.Json[0].Player[0]; }

  token;

  loadProviderData(): Observable<any> {
    let source;
    const metadata = this.data.DataProvider[0].$.metadata;
    if (metadata!=null && metadata!='') {
      source = 'external';
    } else {
      source = this.data.DataProvider[0].$.source;
    }

    let folder;
    if (source=='cloud') {
      folder = 'eventparams'
    } else if (source=='external') {
      let key;
      let user;

      folder = metadata;
      switch (metadata) {
        case 'pinterest.board':
          key = this.data.Json[0].Data[0].$.key;
          const board = this.data.Json[0].Data[0].$.board;
          this.url = DS_API_URL + "PinterestBoardPins/" +  key +  "/" + board;
          break;

        case 'pinterest.user':
          key = this.data.Json[0].Data[0].$.key;
          this.url = DS_API_URL + "PinterestUserPins/" +  key;
          break;

        case 'drive':
          this.token = this.data.Json[0].Data[0].$.token;
          const id = this.data.Json[0].Data[0].$.id;
          this.url = DS_API_URL + "GoogleDriveFolderFiles" + "/" + this.token + "/" + id;
          break;

        case 'dropbox':
          this.token = this.data.Json[0].Data[0].$.token;
          const path = this.data.Json[0].Data[0].$.path;
          this.url = DS_API_URL + "DropboxFiles/" +  this.token + "/" + path;
          break;

        case "tumblr.posts":
          this.token = this.data.Json[0].Data[0].$.token;
          user = this.data.Json[0].Data[0].$.user;
          this.url = DS_API_URL + "TumblrAllPosts/" +  this.token +  "/" + user;
          break;

        case "tumblr.videos":
          this.token = this.data.Json[0].Data[0].$.token;
          user = this.data.Json[0].Data[0].$.user;
          this.url = DS_API_URL + "TumblrAllVideos/" +  this.token +  "/" + user;
          break;

        case "tumblr.texts":
          this.token = this.data.Json[0].Data[0].$.token;
          user = this.data.Json[0].Data[0].$.user;
          this.url = DS_API_URL + "TumblrAllText/" +  this.token +  "/" + user;
          break;

        case "tumblr.photos":
          this.token = this.data.Json[0].Data[0].$.token;
          user = this.data.Json[0].Data[0].$.user;
          this.url = DS_API_URL + "TumblrAllPhotos/" +  this.token +  "/" + user;
          break;

        case "facebook.wall":
          this.token = this.data.Json[0].Data[0].$.token;
          this.url = DS_API_URL + "facebook/getWall/" +  this.token;
          break;

        case "facebook.album":
          this.token = this.data.Json[0].Data[0].$.token;
          const albumId = this.data.Json[0].Data[0].$.id;
          this.url = DS_API_URL + "facebook/getPhotosOfAlbums/" +  this.token +  "/" + albumId;
          break;

        case "facebook.videos":
          this.token = this.data.Json[0].Data[0].$.token;
          this.url = DS_API_URL + "facebook/getVideos/" +  this.token;
          break;

        case "500px.user":
          this.token = this.data.Json[0].Data[0].$.token;
          user = this.data.Json[0].Data[0].$.user;
          this.url = DS_API_URL + "500pxPhotos/" + this.token + "/" + user + "/2048";
          break;

        case "twitter":
          this.token = this.data.Json[0].Data[0].$.token;
          let screenName = this.data.Json[0].Data[0].$.screenName;
          if (screenName==null) {
            screenName = "";
          }
          this.url = DS_API_URL + "TwitterHome/" +  this.token + "/" +  screenName;
          break;
        case "instagram.feed":
          this.token = this.data.Json[0].Data[0].$.token;
          this.url =  DS_API_URL + "InstagramFeed/" +  this.token;
          break;

        case "calendar":
          let d1:Date = new Date();
          let d2:Date = new Date();

          if (this.data.Json[0].Data[0].$.mode=="fixed")
          {
            d1 = new Date(Number(this.data.Json[0].Data[0].$.startDate) + d1.getTimezoneOffset() * 60000);
            d2 = new Date( Number(this.data.Json[0].Data[0].$.endDate) + d2.getTimezoneOffset() * 60000 + (1000 * 60 * 60 * 24));
          }
          else
          {
            let before = this.data.Json[0].Data[0].$.before;
            let after = this.data.Json[0].Data[0].$.after + 1;

            d1 = new Date(Date.UTC(d1.getUTCFullYear(), d1.getUTCMonth(), d1.getUTCDate()) + d1.getTimezoneOffset() * 60000 - (before * 1000 * 60 * 60 * 24));
            d2 = new Date(Date.UTC(d2.getUTCFullYear(), d2.getUTCMonth(), d2.getUTCDate()) + d2.getTimezoneOffset() * 60000 + (after * 1000 * 60 * 60 * 24));
          }
          this.url = DS_API_URL + "GoogleCalendarEvents/" +
            this.data.Json[0].Data[0].$.token + "/" + this.data.Json[0].Data[0].$.id +"/" +
            d1.getUTCFullYear() + "-" + (d1.getUTCMonth() + 1).toString() + "-" + (d1.getUTCDate()).toString() + "T" + d1.getUTCHours() + ":" + d1.getUTCMinutes() + ":" + d1.getUTCSeconds() + "Z" + "/" +
            d2.getUTCFullYear() + "-" + (d2.getUTCMonth() + 1).toString() + "-" + (d2.getUTCDate()).toString() + "T" + d2.getUTCHours() + ":" + d2.getUTCMinutes() + ":" + d2.getUTCSeconds() + "Z";
          break;

        case "spreadsheet":
          this.token = this.data.Json[0].Data[0].$.token;
          const sheetId = this.data.Json[0].Data[0].$.id;
          this.url = DS_API_URL + "GoogleSheetsValues/" + this.token + "/" + sheetId + "/0/";
          break;

        case "instagram.media":
          this.token = this.data.Json[0].Data[0].$.token;
          this.url = DS_API_URL + "InstagramFeed/" + this.token + "/";
          break;

        default:
            folder = "urls";
          this.url = this.getUrl();
          break;
      }
    }
    const pd = this.data.DataProvider[0].$;
    return this.playerService.loadProviderData(pd.eventName, source, this.url, folder);
  }

  getUrl() {
    const logInfo = Log.getLogInfo("JsonListComponent", "getUrl", []);
    let url = this.data.DataProvider[0].$.url;
    if (url==null) {
      Log.w(logInfo, LogTag.PLAYER, "url is null");
      return of(null);
    }
    let i1=0
    while(true) {
      i1 = url.indexOf('$[', i1);
      if (i1==-1) {
        break;
      }
      let i2 = url.indexOf(']', i1);
      if (i2==-1) {
        break;
      }
      const name = url.substring(i1+2, i2);
      let value = this.playerService.eventParams.getParam(name);
      url = url.substring(0, i1) + value + url.substring(i2+1);
      i1 = i2;
    }
    return url;
  }



}
